import React from "react";
import PaymentList from "../../../payments/PaymentList";
import { useParams } from "react-router-dom";
import { EntityType } from "@propertelligent/client-api";
import CurrentTenantPaymentList from "../../../payments/CurrentTenantPaymentList";
import ContractorPaymentList from "../../../payments/ContractorPaymentList";
 
interface PaymentTabContentProps {
   result: any[];
   entityTypeId?: EntityType;
   refreshTrigger?: number; // New prop to trigger refresh
   onRefresh?: () => void;
    expensesDueRaw?: number | string;
  expensesDue?: number | string;
 }

 const PaymentTabContent: React.FC<PaymentTabContentProps> = ({ result, entityTypeId, refreshTrigger, onRefresh, expensesDue, expensesDueRaw }) => {
  const { id } = useParams<{ id: string }>();

  return (
    <>
      {entityTypeId === EntityType.Tenant ? (
        <CurrentTenantPaymentList isEntity={true} entityTypeId={entityTypeId} entityId={Number(id)} detailsActiveTab="Payments" refreshTrigger={refreshTrigger} onRefresh={onRefresh}  expensesDue={expensesDue} expensesDueRaw={expensesDueRaw} />

      ) : entityTypeId === EntityType.Contractor ? (
       
        <ContractorPaymentList isEntity={true} entityTypeId={entityTypeId} entityId={Number(id)} detailsActiveTab="Payments" refreshTrigger={refreshTrigger} onRefresh={onRefresh} expensesDue={expensesDue} expensesDueRaw={expensesDueRaw}/>

      ) : (
        <PaymentList
          isEntity={true}
          entityTypeId={entityTypeId}
          entityId={Number(id)}
          className="no-side-margin"
          refreshTrigger={refreshTrigger}
          onPaymentAdded={onRefresh}
        />
      )}
    </>
  );
};

export default PaymentTabContent;
